module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAS0lEQVQokd2RMQoAIAwDL+K/dNUPO/uyuouCFAfx1pDSJAJIqRgOem8CEICZ6waSAAgu90TcCTnXk/cei3Ovk8P8Kx7r5LOJr6wzAPHcF0hkJX69AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/06c.png
// module id = p6Wl
// module chunks = 64